/** @format */

import { Row } from 'components/ui/Grid';
import styled from 'styled-components';

const Wrapper = styled(Row)`
  position: relative;
`;

Wrapper.displayName = '   Wrapper';
export default Wrapper;
